"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSysLevelPresetFromEnv = void 0;
const SysLevelPreset = {
    Local: {
        batchSpansToCollector: false,
        collectorDomain: 'gto-ocp.icproxy.sece.c1.vanguard.com',
        exportSpansToConsole: true,
    },
    Eng: {
        batchSpansToCollector: false,
        collectorDomain: 'gto-ocp.icproxy.sece.c1.vanguard.com',
        exportSpansToConsole: false,
    },
    Test: {
        batchSpansToCollector: true,
        collectorDomain: 'gto-ocp.icproxy.sect.c1.vanguard.com',
        exportSpansToConsole: false,
    },
    Prod: {
        batchSpansToCollector: true,
        collectorDomain: 'gto-ocp.icproxy.secp.c1.vanguard.com',
        exportSpansToConsole: false,
    },
};
function getSysLevelPresetFromEnv(sysLevelString) {
    const sysLevelStringUpper = sysLevelString.toUpperCase();
    const engSysLevels = ['CI', 'ENG', 'DEV', 'INT'];
    const testSysLevels = ['SAT', 'CAT', 'PRF', 'CLT', 'TDT', 'TEST', 'TST'];
    const prodSysLevels = ['PRD', 'PROD'];
    if (engSysLevels.includes(sysLevelStringUpper)) {
        return SysLevelPreset.Eng;
    }
    else if (testSysLevels.includes(sysLevelStringUpper)) {
        return SysLevelPreset.Test;
    }
    else if (prodSysLevels.includes(sysLevelStringUpper)) {
        return SysLevelPreset.Prod;
    }
    console.log('@vanguard/otl-vanguard-wrapper: Could not recognize syslevel environment variable, defaulting to local', sysLevelString);
    return SysLevelPreset.Local;
}
exports.getSysLevelPresetFromEnv = getSysLevelPresetFromEnv;
